export interface Role {
  id: string;
  businessRole: string;
  entityIds: string[];
}

export enum BusinessRole {
  PerformanceAdmin = 'PERFORMANCE_ADMIN',
  CustomerOfferUser = 'CUSTOMER_OFFER_USER',
  DrGeneralUser = 'DR_GENERAL_USER',
  UtilityDispatchUser = 'UTILITY_DISPATCH_USER',
}